angular.module('unergie.main')
.directive('userInfoContractBalanceExplanation', (DataAccess, NgTableParams, BoFeaturesService, AlertManager, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractBalanceExplanation.html',
        link($scope) {
            const typeTranslation = {
                INITIAL: 'Initial',
                REJECT: 'Rejet de paiement',
                CANCEL: 'Annulation',
                TIMETABLE: 'Échéancier',
                FEE: 'Frais',
                INVOICE: 'Facture',
                MANUAL: 'Ajustement manuel',
                DEPOSIT: 'Dépôt de garantie',
                RECOVERY: 'Recouvrement',
                UNDETERMINED: 'Indéterminé',
            }
            $scope.showMetabaseLink = BoFeaturesService.get('isEnvProd') && BoFeaturesService.isFeatureOn('billingAdmin')

            $scope.refresh = () => {
                $scope.refreshing = true
                return DataAccess.explainBalance({ id_contract: $scope.contract.id }).$promise
                .then((explanations) => {
                    _.each(explanations, (e) => {
                        e.typeLbl = typeTranslation[e.type]
                    })
                    $scope.explanations = new NgTableParams({ sorting: { date: 'desc' } }, { dataset: explanations })
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.refreshing = false
                })
            }
        },
    })
)
